import { useEffect, useState } from "react";
import { api, asArray } from "@/lib/api";
import { StatusBadge } from "@/components/Primitives";

export default function Inventory() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("");
  useEffect(() => { api.get("/inventory").then(r => setItems(asArray(r.data))); }, []);
  const cats = Array.from(new Set(items.map(i => i.category)));
  const filtered = items.filter(i => !cat || i.category === cat);
  return (
    <div className="space-y-4">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.18em] text-zinc-500 font-mono">Inventory Management</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight mt-1">Inventory ({filtered.length})</h1>
        </div>
        <select value={cat} onChange={e=>setCat(e.target.value)} data-testid="inventory-category-filter" className="bg-zinc-950 border border-zinc-800 rounded-md px-3 py-1.5 text-sm">
          <option value="">All categories</option>
          {cats.map(c => <option key={c}>{c}</option>)}
        </select>
      </div>
      <div className="bg-zinc-950 border border-zinc-900 rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-zinc-900/50 border-b border-zinc-900 text-[10px] uppercase tracking-widest text-zinc-500 font-mono">
            <tr>
              <th className="text-left px-4 py-3">Name</th><th className="text-left px-4 py-3">SKU</th><th className="text-left px-4 py-3">Warehouse</th>
              <th className="text-left px-4 py-3">Qty</th><th className="text-left px-4 py-3">Unit Cost</th><th className="text-left px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody>
            {filtered.slice(0, 200).map(i => (
              <tr key={i.id} className="border-b border-zinc-900 hover:bg-zinc-900/40">
                <td className="px-4 py-2">{i.name}</td>
                <td className="px-4 py-2 font-mono text-xs text-zinc-500">{i.sku}</td>
                <td className="px-4 py-2 text-zinc-400">{i.warehouse}</td>
                <td className="px-4 py-2 font-mono">{i.qty_on_hand}</td>
                <td className="px-4 py-2 font-mono text-emerald-400">${i.unit_cost_usd}</td>
                <td className="px-4 py-2"><StatusBadge status={i.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
